import { PaginazioneVO } from "./paginazioneVO";
import { DettaglioErroreVO } from "./dettaglio-erroreVO";

export class BaseResponseVO {
  stato: string;
  descrizione: string;
  paginazione: PaginazioneVO;
  errori: DettaglioErroreVO[];
}
